export default __webpack_public_path__ + "static/media/ZM.e27fdd1b.svg";